// Connectivity state for offline mode. Thin wrapper over the browser's
// online/offline events so components can react without each wiring listeners.

export function isOnline() {
  return typeof navigator === "undefined" ? true : navigator.onLine !== false;
}

export function onNetChange(cb) {
  const on = () => cb(true);
  const off = () => cb(false);
  window.addEventListener("online", on);
  window.addEventListener("offline", off);
  return () => {
    window.removeEventListener("online", on);
    window.removeEventListener("offline", off);
  };
}
